import { combineReducers } from "redux";

import keyPerformanceIndicators from "./keyPerformanceIndicators";

const reducer = combineReducers({
    keyPerformanceIndicators
});

export default reducer;
